import {useState, useEffect} from 'react';
import { useIsMobile } from '../../hooks/isMobile';
import { useRef } from 'react';
import gsap from 'gsap'
import { useGSAP } from '@gsap/react'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
// import { SplitText } from 'gsap/SplitText'

import Button from "../../components/Button/Button";
import MerchCarousel from "../../components/MerchCarousel/MerchCarousel";

import Merch1 from "../../assets/images/Photo/Merch/merch1.png";
import Merch2 from "../../assets/images/Photo/Merch/merch2.png";
import Merch3 from "../../assets/images/Photo/Merch/merch3.png";
import Merch4 from "../../assets/images/Photo/Merch/merch4.png";
import Merch5 from "../../assets/images/Photo/Merch/merch5.png";
import Merch6 from "../../assets/images/Photo/Merch/merch6.png";
import Merch7 from "../../assets/images/Photo/Merch/merch7.webp";

import {ReactComponent as Star} from "../../assets/images/Doodles/star.svg";
import {ReactComponent as Star2} from "../../assets/images/Doodles/star_2.svg";
import {ReactComponent as Smiley} from "../../assets/images/Doodles/smiley.svg";
import {ReactComponent as Idea} from "../../assets/images/Doodles/idea.svg";
import { useTranslation } from 'react-i18next';
gsap.registerPlugin(ScrollTrigger)


function Wear({className}) {
    const { t } = useTranslation(['common']);
    const merchCarouselSection = useRef();
    const titleRef = useRef();
    const entireWearSection = useRef();

    useGSAP(() => {
        let mm = gsap.matchMedia();

        mm.add("(max-width: 767px)", () => {
            gsap.delayedCall(0.2, () => {
                gsap.timeline({ repeat: -1, yoyo:true })
                    .to(".wear-animate", {
                    rotation: 20,
                    duration: 0.4,
                    delay: 1,
                    ease: "power2.out",
                    stagger: {
                        each: 0.3,
                        from: "random"
                    }
                    })
                    .to(".wear-animate", {
                    rotation: -10,
                    duration: 0.4,
                    delay:1,
                    ease: "power2.out",
                    stagger: {
                        each: 0.7,
                        from: "random"
                    }
                    })
                    .to(".wear-animate", {
                    rotation: 12,
                    duration: 0.4,
                    delay: 1,
                    ease: "power2.out",
                    stagger: {
                        each: 1,
                        from: "center"
                    }
                    });
            });
        })
        
    }, { scope: merchCarouselSection });

    const isMobile = useIsMobile();
    const images = [
        Merch1,
        Merch2,
        Merch3,
        Merch4,
        Merch5,
        Merch6,
        Merch7
    ];
    
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 2000); // Cambia cada 2 segundos

        return () => clearInterval(interval);
    }, [images.length]);

    return(
        <div ref={entireWearSection} id='section-wear' className={`section-wear flex relative flex-col justify-between pt-8 min-h-screen items-center ${className}`}>
            <div className="hidden md:flex h-[500px] w-full md:flex-col md:justify-center mb-8">
                <MerchCarousel/>
            </div>
            
            <div className="block md:hidden  absolute inset-0">
                {images.map((image, index) => (
                <div
                    key={index}
                    className={`absolute overflow-hidden inset-0 w-full transition-opacity duration-500 ${
                    index === currentImage ? 'opacity-100' : 'opacity-0'
                    }`}
                >
                    <img
                    src={image}
                    alt={`Merch ${index + 1}`}
                    className="h-full w-full object-cover"
                    />
                    {/* Overlay oscuro para mejor legibilidad */}
                    <div className="absolute inset-0 bg-gradient-to-b from-bluekali-white/50 to-bluekali-tomato/50"></div>
                    <div className="absolute inset-0 bg-black/50"></div>
                    
                </div>
                ))}
            </div>
            {/* <h3>merch carousel</h3> */}
            <div ref={merchCarouselSection} className="flex flex-col h-full md:h-auto justify-center md:justify-end items-center overflow-hidden absolute md:static">
                <div className='relative flex flex-col w-4/5 md:w-2/3 items-center'>
                    <div ref={titleRef} className='relative'>
                        <h1 className="wear-title text-4xl md:text-5xl px-6 md:w-auto font-bold text-center">
                            <span>
                                {t('wear.title')}&nbsp;
                            </span>
                            <span className="text-bluekali-tomato md:text-bluekali-han-purple font-crayon">
                                {t('wear.title2')}
                            </span>
                        </h1>

                        { isMobile && 
                            <Star className="wear-animate absolute top-0 right-0 h-8 transform -translate-y-8 block md:hidden"/>
                        }
                    </div>
                    
                    <h3 className="text-center px-6 mt-2 md:w-5/6 text-bluekali-white/80">{t('wear.desc')}</h3>
                    {/* <Button filled='roccolpz!!' className="mb-20 mt-20 md:mt-4">
                        <h3 className="font-bold text-bluekali-tomato p-2 md:p-1">{t('wear.cta')}</h3>
                    </Button> */}
                    <Button filled='roccolpz!!' className="mb-20 mt-20 md:mt-4 cursor-default">
                        <h3 className="font-bold text-bluekali-tomato p-2 md:p-1 opacity-50 ">{t('wear.soon')}</h3>
                    </Button>

                    { isMobile &&
                        <Idea className="wear-animate absolute bottom-40 left-0 h-16 w-auto -rotate-12 block md:hidden"/>
                    }
                </div>
                
                {
                    isMobile && (
                        <>
                        <Star2 className="wear-animate absolute bottom-10 right-0 -rotate-12 h-32 w-auto mb-14 mr-4 transform translate-x-1/3 block md:hidden"/>
                        <Smiley className="wear-animate absolute top-0 left-0 -rotate-12 h-32 w-auto transform -translate-x-1/3 block md:hidden"/>
                        </>
                )}
            </div>
        </div>
    );   
}

export default Wear;